<template>
    <div class="flex items-center px-4sm:px-6">
        <div class="min-w-0 flex-1 flex items-center">
            <div class="flex-shrink-0">
                <img class="h-12 w-12 rounded-full" :src="source" alt="" :imgClass="imgClass" />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "ImageItem",

    props: {
        source: {
            type: String,
            required: false
        },
        imgClass: {
            default: '',
            type: String,
            required: false
        }
    }
}

</script>
